import React from 'react';
import { Link } from 'react-router-dom';
import '../css/hero.css';
import homeImage from '../assets/home2.avif';

const Hero = () => {
  return (
    <section id="home" className="banner" aria-label="Homepage hero banner">
      <div className="banner__background">
        <img src={homeImage} alt="Anu Flow Control Industrial Banner" />
      </div>
      <div className="banner__inner">
        {/* Text content on left side */}
        <div className="hero" role="region" aria-labelledby="hero-title">
          <span className="kicker">Industrial Excellence</span>
          <h1 id="hero-title">Precision Engineered by  Anu Flow Control</h1>
          <p className="lead">
            Professional Industrial Valve Manufacturing Company
            with over 20 years of experience. 
           
          </p>
          <div className="cta-row" role="group" aria-label="Primary actions">
            <Link className="btn btn--primary" to="/gate-valves" aria-label="View products">View Products</Link>
            <Link className="btn btn--ghost" to="/contact" aria-label="Contact us">Contact Us</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
